import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';
import { isValidJson, goToCNTracking } from '../../../../../services/helpers';

export const pickupTrackingAction = {
  GET_PICKUP_DATA: 'GET_PICKUP_DATA'
};

export const getPickupDataAction = load => ({
  type: pickupTrackingAction.GET_PICKUP_DATA,
  payload: load
});

const setLocalStorage = (data, userProfile) => {
  if (!userProfile) {
    return;
  }
  let storage = {};

  if (window.localStorage && window.localStorage.getItem('PICKUP')) {
    storage = isValidJson(window.localStorage.getItem('PICKUP'));
  }

  if (!storage[userProfile.user_id]) {
    storage[userProfile.user_id] = [];
  }
  const notPresent = storage[userProfile.user_id].every(obj => {
    return obj.pickupId !== data.pickup.id;
  });
  if (notPresent) {
    if (storage[userProfile.user_id].length === 5) {
      storage[userProfile.user_id].pop();
    }

    storage[userProfile.user_id].unshift({
      pickupId: data.pickup.id,
      clientCode: data.pickup.clientCode
    });
  }
  window.localStorage.setItem('PICKUP', JSON.stringify(storage));
};

const FailurePayload = (dispatch, res) => {
  dispatch(
    getPickupDataAction({
      isLoading: false,
      isLoaded: true,
      pickupData: [],
      error: (res && res.errorMessage) || 'Could not get tracking information'
    })
  );
};

export const getPickupTrackingData = (
  searchPickupId,
  userProfile
) => dispatch => {
  dispatch(
    getPickupDataAction({
      isLoading: true,
      isLoaded: false,
      pickupData: [],
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pickuptracking',
    method: 'GET',
    pathVariables: [{ key: '{searchpickupid}', val: searchPickupId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        setLocalStorage(res.payload, userProfile);
        dispatch(
          getPickupDataAction({
            isLoading: false,
            isLoaded: true,
            pickupData: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        FailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      FailurePayload(dispatch, res);
    },
    catchCb: res => {
      FailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};
